import React from 'react';
import { 
  HelpCircle, 
  Calculator, 
  Layers, 
  DollarSign, 
  Cog, 
  Clock, 
  Grid, 
  BoxSelect 
} from 'lucide-react';

/**
 * Компонент с советами по 3D-печати и снижению затрат
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Layers,
      title: 'Оптимизация материала',
      description: 'Используйте меньшую плотность заполнения (10-20%) для некритичных деталей. Размещайте модель для минимального использования поддержек.'
    },
    {
      icon: Calculator,
      title: 'Настройки принтера',
      description: 'Уменьшите высоту слоя для лучшего качества или увеличьте для более быстрой печати. Оптимизируйте скорость перемещения для баланса времени и качества.'
    },
    {
      icon: BoxSelect,
      title: 'Масштабирование',
      description: 'Печать нескольких мелких деталей одновременно более эффективна, чем печать по отдельности за счет уменьшения времени разогрева и перемещений.'
    },
    {
      icon: DollarSign,
      title: 'Выбор материала',
      description: 'PLA обычно дешевле и проще в печати, чем ABS или PETG. Рассмотрите переработанные филаменты для нетребовательных проектов.'
    },
    {
      icon: Clock,
      title: 'Ускорение печати',
      description: 'Используйте более толстые слои (0.2-0.3 мм) и сопла большего диаметра (0.6-0.8 мм) для значительного ускорения печати непрецизионных деталей.'
    },
    {
      icon: Cog,
      title: 'Техобслуживание',
      description: 'Регулярно обслуживайте принтер для снижения риска неудачной печати. Проверяйте калибровку стола, состояние сопла и механизмов подачи.'
    },
    {
      icon: Grid,
      title: 'Постобработка',
      description: 'Для гладкой поверхности используйте шлифовку и/или химическую обработку (ацетон для ABS, хлороформ для PLA). Применяйте грунтовку перед окраской.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-teal-500" />
        Советы по 3D-печати
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-teal-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-teal-50 dark:bg-teal-900/20 border border-teal-100 dark:border-teal-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <Calculator className="w-5 h-5 text-teal-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-teal-700 dark:text-teal-300 mb-2">
              Снижение стоимости 3D-печати
            </h4>
            <p className="text-xs text-teal-600 dark:text-teal-400 mb-3">
              Использование оптимизированных настроек в слайсере может снизить расход материала на 30-50% при сохранении прочности и качества детали.
            </p>
            <p className="text-xs text-teal-700 dark:text-teal-300 font-medium">
              Основные рычаги снижения себестоимости:
            </p>
            <ul className="text-xs text-teal-600 dark:text-teal-400 mt-1 space-y-1 list-disc pl-4">
              <li>Оптимизация ориентации модели</li>
              <li>Уменьшение плотности заполнения</li>
              <li>Пакетная печать нескольких моделей</li>
              <li>Выбор оптимального материала</li>
              <li>Тонкая настройка параметров поддержек</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;